// Copyright (c) 2017 TrainHeroic LLC
// Actions for Summary
import FEED_ACTIONS from '../feed/actions';

const SUMMARY_ACTIONS = {
    CALENDAR_LOAD_ATHLETE_SUMMARY: 'calendar-load-athlete-summary',
    CALENDAR_LOAD_TEAM_SUMMARY: 'calendar-load-team-summary',
    SUMMARY_ADD_ATHLETE_SUMMARY: 'summary-add-athlete-summary',
    FEED_ITEM_LIKE: 'feed-item-like',
    COMMENT_ADD_DELETE: 'comments-add-delete',
    CALENDAR_LOAD_ATHLETE_SUMMARY_LAST_COMMENT: 'calendar-last-comment'
};

// merging these because we share the reducer between the calendar and designer
const actions = Object.assign({}, SUMMARY_ACTIONS, FEED_ACTIONS);
export default actions;



// WEBPACK FOOTER //
// ./src/state/reducer/summary/actions.js